document.addEventListener('DOMContentLoaded', () => {
  const serviceBlurbs = document.querySelectorAll('.sub_service_blurb')

  serviceBlurbs.forEach(serviceBlurb => {
    // Create a dialog element
    const dialog = document.createElement('dialog')
    dialog.classList.add('service_dialog')

    // Create and fill the header
    const header = document.createElement('header')
    header.classList.add('service_dialog-header')

    let headers = serviceBlurb.querySelectorAll(
      '.et_pb_module_header span:has(span) > span'
    )
    if (headers.length === 0) {
      headers = serviceBlurb.querySelectorAll('.et_pb_module_header > span')
    }

    const headerContent = Array.from(headers).map(span => span.textContent.trim());
    header.textContent = headerContent.join(' / ');
    dialog.appendChild(header)

    // Create and fill the body
    const body = document.createElement('div')
    body.classList.add('service_dialog-content')

    const description = serviceBlurb.querySelector('.et_pb_blurb_description')
    if (description) {
      body.innerHTML = description.innerHTML
    }
    dialog.appendChild(body)

    // Append the dialog to the serviceBlurb
    serviceBlurb.after(dialog)

    // Add click event listener to serviceBlurb to open the dialog
    serviceBlurb.addEventListener('click', () => {
      dialog.showModal()
      dialog.classList.add('show')
    })

    // Optional: Add a close button inside the dialog
    const closeButton = document.createElement('button')
    closeButton.innerHTML = '&times;'
    closeButton.classList.add('service_dialog-close')

    closeButton.addEventListener('click', () => {
      dialog.close()
      dialog.classList.remove('show')
    })
    header.appendChild(closeButton)
  })
})
